import * as dealerTypes from 'modules/dealers/actionTypes';
import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<string>?} State */
const initialState = [];

const updatePredefinedMessages = (_, { payload }) =>
  payload.content.map(({ id: predefinedMessageId }) => predefinedMessageId);

const removeOne = (state, { payload: removedId }) =>
  state.filter(predefinedMessageId => predefinedMessageId !== removedId);

export default createReducer(initialState, {
  [types.FETCH_ALL_BY_DEALER_SUCCESS]: updatePredefinedMessages,
  [dealerTypes.PREDEFINED_MESSAGES_FETCH_SUCCESS]: updatePredefinedMessages,
  [types.DELETE_SUCCESS]: removeOne,
});
